import { Injectable, inject, type Provider } from '@angular/core';

import { BROADCAST_CLOCK } from '../../settings/pages/broadcast/broadcast-clock';
import { BroadcastExternalClickService } from './broadcast-external-click.service';

type BroadcastExternalClickContract = Pick<
  BroadcastExternalClickService,
  keyof BroadcastExternalClickService
>;

/** Preview-only click ledger: same value contract, no network or persistence. */
@Injectable()
export class BroadcastExternalClickPreviewService
  implements BroadcastExternalClickContract
{
  private readonly clock = inject(BROADCAST_CLOCK);

  record(slotId: string): Promise<string | null> {
    if (!slotId?.trim()) return Promise.resolve(null);
    return Promise.resolve(this.clock().toISOString());
  }
}

export const BROADCAST_EXTERNAL_CLICK_PREVIEW_PROVIDER: Provider = {
  provide: BroadcastExternalClickService,
  useClass: BroadcastExternalClickPreviewService,
};
